export const POLL_INTERVAL_MS = 30_000
